module.exports = __webpack_public_path__ + "static/img/threeab.cbd69128.png";